import { gql } from '@apollo/client';

import { PAS_FIND_FRAGMENT } from './getSitePasFindsQuery';

export const CREATE_AMCR_FIND_MUTATION = gql`
  mutation CreateAmcrFindMutation($findId: ID!, $record: AmcrFindRecordInput) {
    createAmcrFind(findId: $findId, record: $record) {
      ... on UpdateFindSuccess {
        find {
          ...PasFindFields
          amcrPasUrl
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
  ${PAS_FIND_FRAGMENT}
`;
